// src/redux/slices/serviceSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const BASE_URL = process.env.REACT_APP_API_URL;

// GET all services
export const fetchServices = createAsyncThunk('services/fetchAll', async (_, thunkAPI) => {
  try {
    const res = await fetch(`${BASE_URL}/get-services`);
    const data = await res.json();
    return data.services || [];
  } catch (err) {
    return thunkAPI.rejectWithValue(err.message);
  }
});

// POST: Add service
export const addService = createAsyncThunk('services/add', async (service, thunkAPI) => {
  try {
    const res = await fetch(`${BASE_URL}/add-service`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(service),
    });
    const data = await res.json();
    return data.service;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.message);
  }
});

// PUT: Update service
export const updateService = createAsyncThunk('services/update', async ({ id, updatedData }, thunkAPI) => {
  try {
    const res = await fetch(`${BASE_URL}/update-service/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(updatedData),
    });
    const data = await res.json();
    return data.service;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.message);
  }
});

// DELETE: Delete service
export const deleteService = createAsyncThunk('services/delete', async (id, thunkAPI) => {
  try {
    await fetch(`${BASE_URL}/delete-service/${id}`, {
      method: 'DELETE',
    });
    return id;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.message);
  }
});

const serviceSlice = createSlice({
  name: 'services',
  initialState: {
    list: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchServices.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchServices.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchServices.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(addService.fulfilled, (state, action) => {
        state.list.push(action.payload);
      })
      .addCase(updateService.fulfilled, (state, action) => {
        const index = state.list.findIndex((s) => s.id === action.payload.id);
        if (index !== -1) state.list[index] = action.payload;
      })
      .addCase(deleteService.fulfilled, (state, action) => {
        state.list = state.list.filter((s) => s.id !== action.payload);
      });
  },
});

export default serviceSlice.reducer;
